import type { ComponentProps, ComponentPropsWithoutRef } from 'react';
import { forwardRef, useId } from 'react';

import { SectionHeading } from './section-heading.component';
import commonStyles from './styles.module.scss';

type Props = {
  heading: ComponentProps<typeof SectionHeading>;
} & ComponentPropsWithoutRef<'section'>;

export const SectionLayoutBase = forwardRef<HTMLElement, Props>(
  ({ heading, children, id }, ref) => {
    const headingId = `heading-${id}-${useId()}`;

    return (
      <section
        aria-labelledby={headingId}
        className={commonStyles.detailCompanySection}
        id={id}
        ref={ref}
      >
        <SectionHeading id={headingId} {...heading} />
        {children}
      </section>
    );
  }
);
SectionLayoutBase.displayName = 'SectionLayoutBase';
